mutation PublishDafStatements($ids: [ID!]!) {
  publishDafStatements(input: { ids: $ids }) {
    success
  }
}
